import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './Components/Header/Header.jsx';
import Home from './Pages/Home/Home.jsx';
import AboutUs from './Pages/AboutUs/About.jsx';
import Footer from './Components/Footer/Footer.jsx';
import StandardCompliance from './Pages/StandardCompliance/StandardCompliance.jsx';
import GlobalExport from './Pages/GlobalExport/GlobalExport.jsx';
import LogisticManagement from './Pages/LogisticManagement/LogisticManagement.jsx';
import MarketCompliance from './Pages/MarketCompliance/MarketCompliance.jsx';
import ExhibitionProgram from './Pages/ExhibitionsProgram/ExhibitionProgram.jsx';
import DistributerCollabration from './Pages/DistributerCollabration/DistributerCollabration.jsx';
import Products from './Pages/Products/Products.jsx';
import ProductDetail from './Pages/Products/ProductDetails.jsx';
import Admin from './Pages/Admin/Admin.jsx';
import ContactUs from './Pages/ContactUs/ContactUs.jsx';
import Services from './Pages/Services/Services.jsx';
import PageTransition from './Components/ScreenLoader/PageTransition.jsx';
import WhatsAppButton from './Components/WhatsAppButton/WhatsAppButton.jsx';
import NotFound from './Components/NotFound/NotFound.jsx';
import CataloguePopup from './Components/CataloguePopup/CataloguePopup.jsx';

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname === '/admin';

  return (
    <>
      {!isAdminRoute && <Header />}
      {!isAdminRoute && <CataloguePopup />}
      <PageTransition>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/AboutUs" element={<AboutUs />} />
          <Route path='/StandardCompliance' element={<StandardCompliance />} />
          <Route path='/GlobalExport' element={<GlobalExport />} />
          <Route path='/LogisticManagement' element={<LogisticManagement />} />
          <Route path='/MarketCompliance' element={<MarketCompliance />} />
          <Route path='/ExhibitionProgram' element={<ExhibitionProgram />} />
          <Route path='/DistributerCollaboration' element={<DistributerCollabration />} />
          <Route path='/Products' element={<Products />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path='/admin' element={<Admin />} />
          <Route path='/ContactUs' element={<ContactUs />} />
          <Route path='/Services' element={<Services />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
        {!isAdminRoute && <WhatsAppButton />}
      </PageTransition>
      {!isAdminRoute && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;

